// The iOS thresholds are MapKit camera distances (meters from camera to
// ground). iOS itself converts distance to a visible latitude span with
// span = distance / 111,000 * 1.5 degrees (GaugeManager.visibleSpan,
// CombinedMapView.scheduleFIMFetch). The web inverts that formula, so every
// threshold in constants.ts keeps its meaning: "the camera is within X" means
// "the visible north-south extent is within 1.5 X".
import { METERS_PER_DEGREE_LAT } from '../config/constants';
import type { Region } from './geo';

export function cameraDistanceForLatSpan(latSpanDegrees: number): number {
  return (latSpanDegrees * METERS_PER_DEGREE_LAT) / 1.5;
}

export function latSpanForCameraDistance(distance: number): number {
  return (distance / METERS_PER_DEGREE_LAT) * 1.5;
}

export function cameraDistanceForRegion(region: Region): number {
  return cameraDistanceForLatSpan(region.latDelta);
}
